import { extend } from '@zg-rentals/zdash';

import AddressConstants from './AddressConstants';
import AnalyticsConstants from './AnalyticsConstants';
import DispatchConstants from './DispatchConstants';
import KeyCodeConstants from './KeyCodeConstants';
import LeadConstants from './LeadConstants';
import PropertiesConstants from './PropertiesConstants';
import PropertyConstants from './PropertyConstants';
import QueryConstants from './QueryConstants';
import ReviewsConstants from './ReviewsConstants';
import StringConstants from './StringConstants';
import LoadingConstants from './LoadingConstants';

const Constants = extend(
  AddressConstants,
  AnalyticsConstants,
  DispatchConstants,
  KeyCodeConstants,
  LeadConstants,
  PropertiesConstants,
  PropertyConstants,
  QueryConstants,
  ReviewsConstants,
  StringConstants,
  LoadingConstants,
);

export default Constants;
